export const OpsMsgTypes = {
  limit: 5,
  statusInProgress: "IN_PROGRESS",
};
